module.exports = __webpack_public_path__ + "static/Flow_1-fc37967891503ac348d159cb4b936db0.png";